/* sb-dc-tplrotcover.js - hide the board until the template has stopped moving.
   2026-09-17 (v5 - hard gates for the two files that rebuild the board).

   Reported (1): a template whose text reads bottom-to-top shows the board
   BROKEN first - the vertical words lying flat and overlapping - and then it
   snaps to correct several seconds later.
   Reported (2): a step & repeat template shows "VOT" / "202" where the
   thumbnail says "VOTE 2026", and that too corrects itself.
   Reported (3): after the cover lifts the board keeps rearranging for 30-40s.

   WHY V3 (measured 2026-09-17, template 6d764faf graduation 8x8, live theme):
   v2 waited on sb-dc-tplrot.js AND sb-dc-tplwidth.js only. tplwidth is not
   loaded any more (see sections/sb-dc-reptileload.liquid), so its check fell
   through to the NO_HELP timer every time and the gate was in effect a fixed
   ~3.5s timer that knew nothing about the work still to come. On a slower
   machine the same template lifted at 5.0s with shrink passes landing at 7.4s
   and 11.4s - in full view of the customer. Same code, same template; only the
   machine differed.

   So v3 does not ask "have my helpers finished". It asks "has the document
   stopped changing", which is the thing the customer actually sees, and which
   stays true no matter which helper is loaded, in what order they run, or
   whether the app's own text fitter (__dcFitAll / __dcFitUpd) writes back
   afterwards.

   WHY V4 (measured 2026-09-17, with sb-dc-tplprefit.js in place)
   With the corrections moved ahead of the paint, the board goes quiet early
   but the cover still sat on it waiting for tplmerge / tplshrink to SAY they
   were done - and they only say so after their own quiet windows:

     step & repeat wordmark    board quiet 2.7s -> cover lifted 6.8s
     step & repeat graduation  board quiet 4.9s -> cover lifted 7.9s

   Those last seconds bought nothing, so a board that has been quiet for
   BYPASS_MS is enough on its own for helpers that only adjust layers in place.

   WHY V5 (measured 2026-09-17, retractable 1cecfc81, preview theme)
   A quiet board is not proof the work has finished - it can also mean the work
   has not started. Caught on this run:

     1.4s / 2.4s  board changes, then quiet
     5.4s         cover lifts (quiet for 1.5s, helpers all reported done)
     4.9s / 5.9s  sb-dc-tplfix.js sets the spec
     7.9s         sb-dc-tplfix.js calls loadTemplate   <- rebuild, in full view
     11.0s        sb-dc-tplboard.js rebuilds again     <- and again

   Those two files REBUILD THE DOCUMENT (new layer ids, different geometry),
   which is the worst thing for the customer to watch, and both of them say in
   their own diagnostics when they are done. So they are hard gates: quiet does
   not override them. The helpers that only adjust layers in place (merge,
   shrink, tilesync, rot) stay soft - a board that has been quiet for BYPASS_MS
   is enough for those, which is what v4 was for.

   Hard gates give up after HARD_MAX so a file that never reports cannot hold
   the cover to the 25s cap on its own.

   Lifts when ALL of these hold:
     - the layer signature has not changed for QUIET_MS
     - the two rebuild files (tplfix, tplboard) report they are done
     - every other helper reports it is done, OR the board has been quiet for
       BYPASS_MS
     - AFTER ms have passed since that first became true
   and at MAX_MS regardless, so this can only ever delay the old behaviour.

   It does not touch layers, the board, or the print file. Delete the one line
   in sections/sb-dc-reptileload.liquid to get the old behaviour back.

   Diagnostics: window.__dcTplRotCover() - includes a timeline of what the gate
   was waiting for, so a slow load can be read off afterwards. */
(function () {
  'use strict';

  var ID      = 'sbdc-rotcover';
  var NAVY    = '#072747';
  var MAX_MS  = 25000;   // hard cap from first paint
  var NO_HELP = 3000;    // a helper never showed up at all - stop waiting on it
  var QUIET_MS = 700;    // document unchanged this long = the board has settled
  var BYPASS_MS = 1500;  // ...and this long means we stop waiting on SOFT helpers
  var HARD_MAX = 15000;  // a rebuild file that never reports is waited on this long
  var AFTER   = 250;     // settle after everything reports done, covers the redraw
  var TICK    = 120;

  var info = {
    shown: false, lifted: false, why: '', ms: 0,
    quietFor: 0, waitingOn: '', changes: 0, lastChangeMs: 0, trail: [], bypassed: false
  };
  window.__dcTplRotCover = function () { return info; };

  function q(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }
  if (!q('tpl')) { info.why = 'no tpl'; return; }

  var t0 = Date.now(), el = null, liftAt = 0;
  var lastSig = null, lastSigAt = Date.now();

  function target() {
    return document.querySelector('.canvas-viewport')
        || document.querySelector('#root .canvas')
        || null;
  }

  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.id = ID;
    el.style.cssText = [
      'position:fixed', 'z-index:60', 'background:#f3f5f8',
      'display:flex', 'align-items:center', 'justify-content:center',
      'flex-direction:column', 'gap:10px',
      'font-family:Arial,Helvetica,sans-serif', 'font-size:13px', 'color:#5b6672',
      'transition:opacity .18s ease', 'pointer-events:none'
    ].join(';');

    var sp = document.createElement('div');
    sp.style.cssText = 'width:22px;height:22px;border:2px solid #c8d2dd;border-top-color:'
      + NAVY + ';border-radius:50%;animation:sbdc-rc-spin .8s linear infinite';

    var tx = document.createElement('div');
    tx.textContent = 'Loading your template...';

    el.appendChild(sp);
    el.appendChild(tx);

    var st = document.createElement('style');
    st.textContent = '@keyframes sbdc-rc-spin{to{transform:rotate(360deg)}}';
    (document.head || document.documentElement).appendChild(st);

    document.body.appendChild(el);
    info.shown = true;
    return el;
  }

  function fit() {
    var t = target();
    if (!t || !el) return;
    var r = t.getBoundingClientRect();
    if (r.width < 40 || r.height < 40) return;
    el.style.left   = r.left + 'px';
    el.style.top    = r.top + 'px';
    el.style.width  = r.width + 'px';
    el.style.height = r.height + 'px';
  }

  function lift(why) {
    if (info.lifted) return;
    info.lifted = true;
    info.why = why;
    info.ms = Date.now() - t0;
    if (el) {
      el.style.opacity = '0';
      setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 220);
    }
    clearInterval(iv);
  }

  /* ---- what the customer would see: the layer signature -------------------
     Everything that moves the board shows up here - a rebuild (ids change), a
     font change from tplshrink, a merge, a tile edit, or the app's fitter
     writing a box width back. Rounded so sub-pixel churn does not count as a
     change. */
  function signature() {
    var api = window.__dcApi;
    var doc = api && (api.front || api.doc);
    var L = doc && doc.layers;
    if (!L || !L.length) return null;
    var out = [];
    for (var i = 0; i < L.length; i++) {
      var l = L[i];
      out.push(
        l.id, l.type,
        Math.round((+l.xIn || 0) * 100), Math.round((+l.yIn || 0) * 100),
        Math.round((+l.widthIn || 0) * 100), Math.round((+l.heightIn || 0) * 100),
        Math.round((+l.fontSizeIn || 0) * 1000), Math.round((+l.rotation || 0) * 10),
        l.type === 'text' ? String(l.text || '') : ''
      );
    }
    return out.join('\u0001');
  }

  /* ---- soft helper gates --------------------------------------------------
     Each returns true when that helper is done, or is not loaded at all. A
     helper that is loaded but still working keeps the cover down - until the
     board has been quiet for BYPASS_MS, after which it speaks for itself. */
  function helper(name, done) {
    var d = null;
    try { d = window[name] && window[name](); } catch (e) {}
    if (!d) return { ready: (Date.now() - t0) > NO_HELP, tag: name + '?' };
    return { ready: !!done(d), tag: name };
  }

  function gates() {
    var out = [];
    /* rotation: done when it applied an angle, or there was none to apply. */
    out.push((function () {
      var d = null;
      try { d = window.__dcTplRot && window.__dcTplRot(); } catch (e) {}
      var age = Date.now() - t0;
      if (!d) return { ready: age > NO_HELP, tag: 'rot?' };
      if (d.why) return { ready: true, tag: 'rot' };
      if (d.pairs === 0) return { ready: age > 1200, tag: 'rot' };
      return { ready: d.applied > 0, tag: 'rot' };
    })());
    out.push(helper('__dcTplMerge',  function (d) { return !!d.settled; }));
    out.push(helper('__dcTplShrink', function (d) { return !!d.settled; }));
    /* tilesync only has to have taken its baseline; its own edits are the
       customer's, not ours. */
    out.push(helper('__dcTileSync',  function (d) { return !!d.started; }));
    return out;
  }

  /* Files that REBUILD the document. Quiet never speaks for these. */
  function hardGates() {
    var age = Date.now() - t0, out = [];

    out.push((function () {
      var d = null;
      try { d = window.__dcTplFixDebug && window.__dcTplFixDebug(); } catch (e) {}
      if (!d) return { ready: age > NO_HELP, tag: 'tplfix?' };
      if (age > HARD_MAX) return { ready: true, tag: 'tplfix' };
      return { ready: !!d.applied, tag: 'tplfix' };
    })());

    out.push((function () {
      var d = null;
      try { d = window.__dcTplBoard && window.__dcTplBoard(); } catch (e) {}
      if (!d) return { ready: age > NO_HELP, tag: 'tplboard?' };
      if (age > HARD_MAX) return { ready: true, tag: 'tplboard' };
      /* 'ok' means the doc on screen is the one it laid out; the rest are
         terminal states where it will never write. */
      var done = { 'ok': 1, 'gave-up': 1, 'not-svg': 1, 'no-viewbox': 1,
                   'no-layers': 1, 'error': 1 };
      return { ready: !!done[d.state], tag: 'tplboard:' + d.state };
    })());

    return out;
  }

  var iv = setInterval(function () {
    var now = Date.now(), age = now - t0;

    if (!info.lifted) { build(); fit(); }

    if (age > MAX_MS) { lift('cap'); return; }

    /* document quiet? */
    var sig = signature();
    if (sig === null) {
      lastSigAt = now;                 // nothing on the board yet - not quiet
    } else if (sig !== lastSig) {
      if (lastSig !== null) {
        info.changes++;
        info.lastChangeMs = age;
        if (info.trail.length < 40) info.trail.push(age);
      }
      lastSig = sig;
      lastSigAt = now;
    }
    var quiet = (sig !== null) && (now - lastSigAt >= QUIET_MS);
    info.quietFor = sig === null ? 0 : (now - lastSigAt);

    var settled = (sig !== null) && (now - lastSigAt >= BYPASS_MS);
    var waiting = [];

    var h = hardGates();
    for (var j = 0; j < h.length; j++) if (!h[j].ready) waiting.push(h[j].tag);

    if (!settled) {
      var g = gates();
      for (var i = 0; i < g.length; i++) if (!g[i].ready) waiting.push(g[i].tag);
    } else if (!info.bypassed) {
      info.bypassed = true;      // board was quiet long enough for the soft ones
    }
    if (!quiet) waiting.push('board');
    info.waitingOn = waiting.join(',');

    if (!waiting.length) {
      if (!liftAt) liftAt = now + AFTER;
      else if (now >= liftAt) lift('ready');
    } else {
      liftAt = 0;
    }
  }, TICK);

  window.addEventListener('resize', fit);
  window.addEventListener('scroll', fit, true);
})();
